(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/bomben-button.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/bomben-button.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.BombenButton = Backbone.Model.extend({
    defaults: {
      bombenButtonMessage: 'Nej',
      showBombenMessage: false,
      missingBomben: false
    },

    initialize: function(options) {
      var hasBomben = options && options.hasBomben,
        bombenMessage = hasBomben ? 'Nej' : 'Av';
      this.set(
        {
          bombenButtonMessage: bombenMessage,
          missingBomben: !hasBomben
        },
        { silent: true }
      );
      this.listenTo(
        svs.tipset.models.bombenXperten,
        'bombenSet bombenRemoved',
        this.setBombenSystemSize
      );
    },

    setBombenSystemSize: function() {
      var isBombenActive =
          svs.tipset.models.bombenXperten &&
          svs.tipset.models.bombenXperten.get('systemSize') > 0,
        bombenMessage = isBombenActive
          ? svs.tipset.models.bombenXperten.get('systemSize') + 'kr'
          : 'Nej';
      this.set({
        bombenButtonMessage: bombenMessage,
        showBombenMessage: isBombenActive
      });
    },

    clearAll: function() {
      this.set(this.defaults);
      this.trigger('bombenGameRemoved');
    }
  });
})(Backbone, _, svs);

 })(window);